// src/pages/compony/SettingsSkeleton.jsx
import React from 'react';

const SkeletonField = ({ full = false }) => (
  <div className={`skeleton-field ${full ? 'skeleton-field-full' : ''}`}>
    <div className="skeleton skeleton-label" />
    <div className="skeleton skeleton-input" />
  </div>
);

export default function SettingsSkeleton() {
  return (
    <div className="skeleton-card">
      <div className="skeleton skeleton-title" />

      <div className="skeleton-grid">
        <SkeletonField />
        <SkeletonField />
        <SkeletonField />
        <SkeletonField />
        <SkeletonField />
        <SkeletonField />
        <SkeletonField full />
        <SkeletonField />
        <SkeletonField />
      </div>

      <div className="skeleton skeleton-btn" />
    </div>
  );
}
